import { render, staticRenderFns } from "./StorefrontDetails.vue?vue&type=template&id=1c590c48&scoped=true"
import script from "./StorefrontDetails.vue?vue&type=script&lang=js"
export * from "./StorefrontDetails.vue?vue&type=script&lang=js"
import style0 from "./StorefrontDetails.vue?vue&type=style&index=0&id=1c590c48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c590c48",
  null
  
)

export default component.exports